import {
  Activity,
  AlarmClock,
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArrowBigRight,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightLeft,
  ArrowUp,
  AtSign,
  Ban,
  Bell,
  BellOff,
  Bolt,
  Book,
  BookMarked,
  Box,
  Boxes,
  Braces,
  Bug,
  Building2,
  Calendar,
  CalendarClock,
  CalendarCog,
  Camera,
  ChartLine,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronUp,
  ChevronsDownUp,
  ChevronsUpDown,
  Circle,
  CircleCheck,
  CircleDashed,
  CircleOff,
  CircleSlash2,
  CircleStop,
  CircleX,
  ClipboardClock,
  Clock,
  ClockArrowDown,
  Cloud,
  Code,
  Cog,
  Component,
  Container,
  Copy,
  CornerDownRight,
  Cpu,
  Croissant,
  Database,
  Disc,
  Edit,
  EllipsisVertical,
  Eye,
  EyeClosed,
  Factory,
  FastForward,
  File,
  FileCode,
  FileJson,
  FileText,
  FileUp,
  Filter,
  Fingerprint,
  Flag,
  Folder,
  Funnel,
  Gauge,
  GitBranch,
  GitCommit,
  GitCommitHorizontal,
  GitMerge,
  GitPullRequest,
  Github,
  Globe,
  Group,
  Hand,
  HardDrive,
  Hash,
  Hexagon,
  Info,
  Key,
  KeyRound,
  Layers,
  LayoutDashboard,
  Link,
  List,
  ListFilter,
  Loader,
  LoaderCircle,
  Lock,
  Mail,
  Map,
  MapPin,
  Maximize2,
  MessageCircle,
  MessageCircleOff,
  MessageSquare,
  Monitor,
  Network,
  Package,
  Pause,
  Play,
  Plug,
  Plus,
  PlusCircle,
  Power,
  PowerOff,
  Puzzle,
  Radio,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Rocket,
  RotateCcw,
  RotateCw,
  Route,
  Rabbit,
  Rss,
  ScrollText,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shuffle,
  Siren,
  Slack,
  SlidersHorizontal,
  Smile,
  Sparkles,
  Split,
  Square,
  Star,
  StepForward,
  StickyNote,
  Tag,
  Terminal,
  Text,
  Trash,
  Trash2,
  TriangleAlert,
  User,
  Users,
  Webhook,
  Workflow,
  X,
  XCircle,
  Zap,
  type LucideIcon,
  LayoutGrid,
} from "lucide-react";

const ICONS = {
  monitor: Monitor,
  activity: Activity,
  "alert-circle": AlertCircle,
  "alert-triangle": AlertTriangle,
  "align-left": AlignLeft,
  "alarm-clock": AlarmClock,
  archive: Archive,
  "arrow-big-right": ArrowBigRight,
  "arrow-right": ArrowRight,
  "arrow-right-left": ArrowRightLeft,
  "arrow-up": ArrowUp,
  "arrow-right-from-line": ArrowRightFromLine,
  "at-sign": AtSign,
  ban: Ban,
  bell: Bell,
  "bell-off": BellOff,
  bolt: Bolt,
  book: Book,
  "book-marked": BookMarked,
  box: Box,
  boxes: Boxes,
  braces: Braces,
  bug: Bug,
  "building-2": Building2,
  calendar: Calendar,
  "calendar-clock": CalendarClock,
  "calendar-cog": CalendarCog,
  camera: Camera,
  "chart-line": ChartLine,
  check: Check,
  "check-circle": CheckCircle,
  "check-circle-2": CheckCircle2,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "chevrons-down-up": ChevronsDownUp,
  "chevrons-up-down": ChevronsUpDown,
  circle: Circle,
  "circle-check": CircleCheck,
  "circle-dashed": CircleDashed,
  "circle-off": CircleOff,
  "circle-slash-2": CircleSlash2,
  "circle-stop": CircleStop,
  "circle-x": CircleX,
  cloud: Cloud,
  "clipboard-clock": ClipboardClock,
  clock: Clock,
  "clock-arrow-down": ClockArrowDown,
  code: Code,
  cog: Cog,
  component: Component,
  container: Container,
  copy: Copy,
  "corner-down-right": CornerDownRight,
  cpu: Cpu,
  croissant: Croissant,
  database: Database,
  disc: Disc,
  edit: Edit,
  "ellipsis-vertical": EllipsisVertical,
  eye: Eye,
  "eye-closed": EyeClosed,
  factory: Factory,
  "fast-forward": FastForward,
  file: File,
  "file-code": FileCode,
  "file-json": FileJson,
  "file-text": FileText,
  "file-up": FileUp,
  filter: Filter,
  fingerprint: Fingerprint,
  flag: Flag,
  folder: Folder,
  funnel: Funnel,
  gauge: Gauge,
  "git-branch": GitBranch,
  "git-commit": GitCommit,
  "git-commit-horizontal": GitCommitHorizontal,
  "git-merge": GitMerge,
  "git-pull-request": GitPullRequest,
  github: Github,
  globe: Globe,
  group: Group,
  hand: Hand,
  "hard-drive": HardDrive,
  hash: Hash,
  hexagon: Hexagon,
  info: Info,
  key: Key,
  "key-round": KeyRound,
  layers: Layers,
  "layout-dashboard": LayoutDashboard,
  "layout-grid": LayoutGrid,
  link: Link,
  list: List,
  "list-filter": ListFilter,
  loader: Loader,
  "loader-circle": LoaderCircle,
  lock: Lock,
  mail: Mail,
  map: Map,
  "map-pin": MapPin,
  "maximize-2": Maximize2,
  "message-circle": MessageCircle,
  "message-circle-off": MessageCircleOff,
  "message-square": MessageSquare,
  network: Network,
  package: Package,
  pause: Pause,
  play: Play,
  plug: Plug,
  plus: Plus,
  "plus-circle": PlusCircle,
  power: Power,
  "power-off": PowerOff,
  puzzle: Puzzle,
  radio: Radio,
  "refresh-ccw": RefreshCcw,
  "refresh-cw": RefreshCw,
  repeat: Repeat,
  rocket: Rocket,
  rabbit: Rabbit,
  "rotate-ccw": RotateCcw,
  "rotate-cw": RotateCw,
  route: Route,
  search: Search,
  send: Send,
  server: Server,
  settings: Settings,
  shield: Shield,
  "shield-alert": ShieldAlert,
  "shield-check": ShieldCheck,
  shuffle: Shuffle,
  siren: Siren,
  slack: Slack,
  "sliders-horizontal": SlidersHorizontal,
  smile: Smile,
  sparkles: Sparkles,
  split: Split,
  square: Square,
  star: Star,
  "step-forward": StepForward,
  "sticky-note": StickyNote,
  tag: Tag,
  terminal: Terminal,
  text: Text,
  rss: Rss,
  "scroll-text": ScrollText,
  trash: Trash,
  "trash-2": Trash2,
  "triangle-alert": TriangleAlert,
  user: User,
  users: Users,
  webhook: Webhook,
  workflow: Workflow,
  x: X,
  "x-circle": XCircle,
  zap: Zap,
} satisfies Record<string, LucideIcon>;

const ICON_ALIASES: Record<string, keyof typeof ICONS> = {
  "admin-panel-settings": "shield-check",
  business: "building-2",
  "box-dashed": "box",
  close: "x",
  dashboard: "layout-dashboard",
  discord: "message-circle",
  elastic: "search",
  "expand-less": "chevron-up",
  "expand-more": "chevron-down",
  gcp: "cloud",
  honeycomb: "hexagon",
  "integration-instructions": "plug",
  label: "tag",
  pencil: "edit",
  schedule: "calendar-clock",
  smtp: "mail",
  teams: "users",
  telegram: "send",
  warning: "triangle-alert",
  "x-mark": "x",
  xmark: "x",
};

function normalizeIconSlug(slug?: string): string | undefined {
  return slug?.trim().toLowerCase().replace(/_/g, "-");
}

function getLucideIcon(slug?: string): LucideIcon | undefined {
  const normalizedSlug = normalizeIconSlug(slug);

  if (!normalizedSlug) {
    return undefined;
  }

  const resolvedSlug = ICON_ALIASES[normalizedSlug] ?? normalizedSlug;

  return ICONS[resolvedSlug];
}

export function resolveLucideIcon(slug?: string, fallbackSlug: string = "puzzle"): LucideIcon {
  return getLucideIcon(slug) ?? getLucideIcon(fallbackSlug) ?? ICONS.puzzle;
}
